import * as yup from "yup";
import moment from "moment";

const personalDetailsSchema = yup.object().shape({
  owner_type: yup.string().nullable(),

  gender: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Gender is required"),
    otherwise: () => yup.string().nullable(),
  }),

  is_married: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Marital status is required"),
    otherwise: () => yup.string().nullable(),
  }),

  is_pa: yup.boolean().nullable(),

  nominee_name: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Nominee Name is required"),
    otherwise: () => yup.string().nullable(),
  }),

  nominee_age: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Age is required"),
    otherwise: () => yup.string().nullable(),
  }),

  nominee_relation: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Nominee Relation is required"),
    otherwise: () => yup.string().nullable(),
  }),

  dob: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Date of Birth is required"),
    otherwise: () => yup.string().nullable(),
  }),

  occupation: yup.string().when("owner_type", {
    is: "IND",
    then: () => yup.string().required("Occupation is required"),
    otherwise: () => yup.string().nullable(),
  }),

  company_slug: yup.string().required(),

  nominee_dob: yup
    .string()
    .nullable()
    .required("Nominee's Date of Birth is required")
    .test("dob", "Please enter a valid date", (val) =>
      moment(val, "YYYY-MM-DD", true).isValid(),
    )
    .when("nominee_relation", {
      is: (relation) =>
        relation !== "Son" &&
        relation !== "Daughter" &&
        relation !== "Mother" &&
        relation !== "Father",

      then: (schema) =>
        schema.test(
          "age-check",
          "Nominee must be at least 18 years old",
          (val) => (val ? moment().diff(moment(val), "years") >= 18 : true),
        ),

      otherwise: (schema) =>
        schema.test(
          "relation-age-check",
          "Invalid age based on relation",
          function (val) {
            const parentDob = this.parent.dob;
            if (!parentDob || !val) return true;

            const relation = this.parent.nominee_relation;
            const nomineeMoment = moment(val);
            const parentMoment = moment(parentDob);

            if (relation === "Son" || relation === "Daughter") {
              return nomineeMoment.isAfter(parentMoment);
            }

            if (relation === "Mother" || relation === "Father") {
              return parentMoment.diff(nomineeMoment, "years") >= 18;
            }

            return true;
          },
        ),
    }),
});

export default personalDetailsSchema;
